import styled from 'styled-components';
import colors from '../../styles/colors';
import { IconButton } from '@material-ui/core';

// export const CallButton = styled.button`
//   background: ${colors.primary};
//   color: #fff;
//   border: 1px solid ${colors.primary};
//   margin: 0 10px;
//   padding: 5px 10px;
//   border-radius: 50%;
//   font-size: 15px;
//   // width: 100px;
//   position: absolute;
//   right: 30px;
//   top: 10px;
//   text-align: center;
// `;

export const CallButton = styled.button`
  background: ${colors.primary};
  color: #fff;
  border: 1px solid ${colors.primary};
  margin: 0 20px;
  font-size: 22px;
  position: absolute;
  right: 40px;
  text-align: center;
  border-radius: 50%;
  padding: 5px 6px 1px 6px;
  top: 10px;
`;

export const CallLinkButton = styled.a`
  background: #00b900;
  color: #fff;
  border: 1px solid #00b900;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
  text-decoration: auto;
  margin: 0 10px;
  padding: 5px 10px;
  border-radius: 30px;
`;

// styles.js
export const MoreIconButton = styled(IconButton)`
  position: absolute;
  right: 0;
  border: 1px solid ${colors.secondary};
  padding: 4px;
  top: 10px;
  margin: 0px 10px;

  /* example: round background */
  // background: ${colors.primary};
  // color: #fff;

  // &:hover {
  //   background: ${colors.primaryDark};
  // }
`;
